<template>
  <d-modal v-if="showModal" size="lg">
    <d-modal-header :close="false" :loading="loading">
      <d-modal-title>Editing Category</d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <div>
        <odd-label>Name</odd-label>
        <d-input
          v-model="name"
          help="hi"
          :state="validName ? null : false"
          class="mb-2"
        />
        <small v-if="!validName">A name is required</small>

        <odd-label>Description</odd-label>
        <quill-editor
          ref="myQuillEditor"
          v-model="description"
          :options="quillOptions"
        />
        <odd-label>Category Photo</odd-label>
        <d-row>
          <d-col cols="12" md="3" lg="2">
            <d-img fluid thumbnail :src="categoryImgSrc" />
          </d-col>
          <d-col cols="12" md="9" lg="10">
            <vue-dropzone
              :maxFiles="1"
              :options="dropzoneOptions"
              @success="handleUploadSuccess"
              duplicateCheck
            />
          </d-col>
        </d-row>
        <d-checkbox class="my-2" v-model="published">PUBLISHED</d-checkbox>
      </div>
      <div class="d-flex justify-content-end align-items-center pt-3">
        <d-button class="mx-2" theme="light" @click="handleClose">
          Cancel
        </d-button>
        <async-button
          @click="updateProductCategory"
          text="Save"
          loadingText="saving..."
          :loading="saving"
        />
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import OddWizard from "@/components/Wizard/Wizard.vue";
import OddWizardTab from "@/components/Wizard/Tab.vue";
import { quillEditor } from "vue-quill-editor";
import quillDefaultOptions from "@/utils/quillOptions";
import VueDropzone from "@/components/vue2-dropzone/components/vue-dropzone.vue";

export default {
  data() {
    return {
      name: "",
      description: "",
      published: false,
      uploadResponse: null,
      key: null,
      header_image: "",
      quillOptions: quillDefaultOptions,
      loading: true,
      saving: false,
      validName: true,
      results: {},
      categoryImgSrc: "",
    };
  },
  props: {
    editPK: {
      type: String,
      default: null,
    },
  },
  computed: {
    showModal() {
      return this.editPK !== null;
    },
    dropzoneOptions() {
      return {
        thumbnailWidth: 150,
        maxFilesize: 0.5,
      };
    },
  },
  components: {
    OddWizard,
    OddWizardTab,
    quillEditor,
    VueDropzone,
  },
  watch: {
    editPK(value) {
      if (value === null) {
        this.resetForm();
      } else {
        this.loadProductCategory();
      }
    },
  },
  methods: {
    resetForm() {
      this.name = "";
      this.description = "";
      this.published = false;
      this.header_image = "";
      this.saving = false;
      this.categoryImgSrc = "";
    },
    loadProductCategory() {
      this.$store
        .dispatch("productCategories/get", this.editPK)
        .then((value) => {
          const base_url =
            process.env.NODE_ENV === "development" ? "http://localhost:8000" : "";
          this.loading = false;
          this.name = value.name;
          this.description = value.description;
          this.published = value.enabled;
          this.header_image = value.header_image;
          if (!!value["thumbnails"] && !!value["thumbnails"]["md_thumbnail"]) {
            this.categoryImgSrc = base_url + value.thumbnails.md_thumbnail;
          }
        });
    },
    onEditorChange({ quill, html, text }) {
      this.description = html;
    },
    handleClose(event) {
      this.$emit("close", event);
    },
    validateName() {
      this.validName = 3 < this.name.length && this.name.length < 100;
    },
    handleUploadSuccess(file, response) {
      this.header_image = response["pk"];
    },
    validate() {
      this.validateName();
      return this.validName;
    },
    updateProductCategory() {
      if (this.validate()) {
        this.saving = true;
        const productCategory = {
          key: this.editPK,
          name: this.name,
          description: this.description,
          enabled: this.published,
          header_image: this.header_image,
        };
        this.$store
          .dispatch("productCategories/update", productCategory)
          .then((result) => {
            this.saving = false;
            this.$emit("dataUpdated");
            this.handleClose();
          });
      }
    },
  },
};
</script>

<style></style>
